import { render, staticRenderFns } from "./TemplateEventsWhatsAppStatusChart.vue?vue&type=template&id=283207e7&scoped=true&"
import script from "./TemplateEventsWhatsAppStatusChart.vue?vue&type=script&lang=js&"
export * from "./TemplateEventsWhatsAppStatusChart.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEventsWhatsAppStatusChart.vue?vue&type=style&index=0&id=283207e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283207e7",
  null
  
)

export default component.exports